module.exports = __webpack_public_path__ + "static/media/office_icon2.bfc15077.svg";